// ...existing code...
import { DffCookieConsentCookie } from "./dff-cookie-consent/dff-cookie-consent-cookie.model";

export interface DffCookieConsentCookieWithDescription extends DffCookieConsentCookie {
    description: string;
}

export function mapCookiesWithDescription(cookies: DffCookieConsentCookie[]): DffCookieConsentCookieWithDescription[] {
    return cookies.map((c) => ({ ...c, description: "" }));
}

function resolveDescription(name: string, lookup: Record<string, string>): string {
    if (lookup[name]) return lookup[name];
    const nameToLower = name.toLowerCase();

    //_pk_id og _pk_ses = Matomo
    if (nameToLower.startsWith("_pk_id.")) return "Matomo (webanalyse): Vedvarende besøg-ID";
    if (nameToLower.startsWith("_pk_ses.")) return "Matomo (webanalyse): Midlertidig sessions-cookie";
    if (nameToLower.startsWith(".aspnetcore.antiforgery")) return "ASP.NET Core: CSRF-beskyttelse for formularer";

    // YouTube / Google
    if (nameToLower.includes("youtube") || nameToLower.includes("yt-")) {
        if (nameToLower === "yt-player-headers-readable") return "YouTube: Afspillerindstillinger og kompatibilitet";
        if (nameToLower === "ytidb::last_result_entry_key") return "YouTube: Afspiller cache/indekseringsnøgle";
        if (nameToLower.startsWith("yt-remote-")) return "YouTube: Fjerncast / enheds- og sessionsdata til Afspiller";
    }
    if (nameToLower === "nid") return "Google: Indholds-/præference-cookie";

    // Genererede ID-lignende tokens (YouTube/Google)
    const looksLikeId = /^[\w\-!:@$]{8,}$/.test(name);
    if (looksLikeId) return "Gemmer identifikatorer til afspiller eller præferencer fra YouTube/Google";

    return "";
}

export function applyDescriptionsByName(
    cookies: DffCookieConsentCookieWithDescription[],
    lookup: Record<string, string> = COOKIE_DESCRIPTIONS
): DffCookieConsentCookieWithDescription[] {
    return cookies.map((c) => ({
        ...c,
        description: resolveDescription(c.name, lookup) || c.description
    }));
}

const COOKIE_DESCRIPTIONS: Record<string, string> = {
    // Nødvendige
    "dff-edb.cookie-consent": "Gemmer dit samtykkevalg (nødvendig for at huske cookie‑indstillinger)",
    __RequestVerificationToken: "CSRF-beskyttelse for formularer (sikkerhed)",
    "ASP.NET_SessionId": "ASP.NET session-ID: Holder din server‑session aktiv",
    chosenPlant: "Husker senest valgt forsyning/værk (funktionel)",
    credentials: "Midlertidig session cache af login‑data (funktionel)",
    "e-boks-popup-vis-aldrig-igen": "Undertrykker e‑Boks popup permanent (funktionel)",
    "e-boks-popup-vis-ikke-igen-i-denne-session": "Undertrykker e-Boks-popup i den aktuelle session",
    "login.index": "Gemmer den senest aktive login-fane",
    "servicerapporter[]": "Gemmer ID’er for valgte servicerapporter",
    user: "Session-kopi af brugerdata for hurtigere adgang",
    yourAuthCookie: "Validerer login og adgangsrettigheder",

    // Valgfrie
    "_pk_id.2627.3d41": "Matomo (webanalyse): Vedvarende besøg-ID",
    "_pk_ses.2627.3d41": "Matomo (webanalyse): Midlertidig sessions-cookie",
    ".AspNetCore.Antiforgery.xr8ki5AOhY8": "ASP.NET Core: CSRF-beskyttelse for formularer",
    "kontaktoplysninger-popup-vist": "Forhindrer, at kontaktoplysninger-popup vises gentagne gange",
    "logget-paa-via-silent-login": "Angiver om du er logget ind via ‘silent login’ i sessionen",

    // YouTube / Google
    "__Secure-ENID": "Google: Sikkerheds-/indholdsdistribution og præferencecookie",
    NID: "Google: Præferencer og indholdstilpasning",
    "yt-player-headers-readable": "YouTube: Afspillerindstillinger og kompatibilitet",
    "yt-remote-cast-available": "YouTube: Fjerncast – tilgængelighed",
    "yt-remote-cast-installed": "YouTube: Fjerncast – installeret",
    "yt-remote-connected-devices": "YouTube: Liste over tilkoblede enheder",
    "yt-remote-device-id": "YouTube: Enheds-ID til fjerncast",
    "yt-remote-fast-check-period": "YouTube: Afspiller – hurtig check periode",
    "yt-remote-session-app": "YouTube: Fjerncast – sessionsapp",
    "yt-remote-session-name": "YouTube: Fjerncast – sessionsnavn",
    "ytidb::LAST_RESULT_ENTRY_KEY": "YouTube: Afspiller cache/indekseringsnøgle"
};
